import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/index';
import About from './pages/about';
import "./assets/css/common.css";
import "./assets/css/buttons.css";
import './App.css';
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard';
import Tables from './pages/tables/Tables';
import FloorPlan from './pages/tables/FloorPlan';
import Reservations from './pages/tables/Reservations';
import Menus from './pages/Menu/Menus';
import DailySalesReport from './pages/Report/DailySalesReport';
import InventoryLogs from './pages/Report/InventoryLogs';
import Settings from './pages/Setting/Setting';
import Order from './pages/Order/Order';
import Stock from './pages/Menu/Stock';
import CustomerMenu from './pages/CustomerMenu/CustomerMenu';
import QRCodePanel from './pages/CustomerMenu/QRCodePanel';
import Reports from './pages/Report/Reports';
import OrderHistory from './pages/Order/OrderHistory';

function App() {
  return (
    <Router>
      <div className="App">
        

        {/* Route Definitions */}
        <Routes>
          <Route path="/test" element={<Home />} />
          <Route path="/about" element={<About />} />


          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tables" element={<Tables />} />
          <Route path="/tables/floor-plan" element={<FloorPlan />} />
          <Route path="/tables/reservation" element={<Reservations />} />
          <Route path="/menu" element={<Menus />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/reports/sales" element={<DailySalesReport />} />
          <Route path="/reports/inventory" element={<InventoryLogs />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/orders" element={<Order />} />
          <Route path="/menu-list" element={<CustomerMenu />} />
          <Route path="/qr-table" element={<QRCodePanel />} />



          <Route path="/reports" element={<Reports />} />
          <Route path="/order-history" element={<OrderHistory />} />




        </Routes>
      </div>
    </Router>
  );
}

export default App;